import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getUserRoles = async () => {
  return base.get({
    url: `${API_PARAM.USER_ROLES}`,
  });
};

export const getUser = async (data) => {
  return base.get({
    url: `${API_PARAM.USER_GET}`.replace(/{id}/, data),
  });
};

export const addUser = async (data) => {
  return base.post({
    url: `${API_PARAM.USERS}`,
    data,
    nonceHeader: true
  });
};

export const editUser = async (data) => {
  return base.patch({
    url: `${API_PARAM.USERS}`,
    data
  });
};

export const deleteUser = async (data) => {
  return base.deleteRequest({
    url: `${API_PARAM.USERS}`,
    data
  });
};

export const restoreUser = async (data) => {
  return base.patch({
    url: `${API_PARAM.USER_RESTORE}`,
    data
  });
};

export const exportUsersGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.USERS_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.USERS),    
  });
};
